import { ModalContainer } from "components/ModalSystem/styles";

export default function LandingVideo() {
	return (
		<ModalContainer size="noraml">
			<iframe width="560" height="315" src="https://www.youtube.com/embed/4jVKAIyLkNU" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
		</ModalContainer>
	)
}
